export default __webpack_public_path__ + "static/media/banner-section-decore.7fe5dc72.svg";